import React from "react";
import {
  PurposeAndBalanceIllustration,
  ImaginationAndCreativityIllustration,
  PatternsAndPrinciplesIllustration,
  StoriesAndSignalsIllustration,
  IndividualsAndGroupsIllustration,
  SustainabilityAndSystemsIllustration,
  PurposeAndBalanceIllustrationV2,
  ImaginationAndCreativityIllustrationV2,
  PatternsAndPrinciplesIllustrationV2,
  StoriesAndSignalsIllustrationV2,
  IndividualsAndGroupsIllustrationV2,
  SustainabilityAndSystemsIllustrationV2,
} from "SvgComponents";

export const IllustrationMap = {
  PurposeAndBalance: (
    <PurposeAndBalanceIllustration
      style={{ position: "absolute", bottom: -20 }}
    />
  ),
  IndividualsAndGroups: (
    <IndividualsAndGroupsIllustration
      style={{ position: "absolute", bottom: -20 }}
    />
  ),
  SustainabilityAndSystems: (
    <SustainabilityAndSystemsIllustration
      style={{ position: "absolute", bottom: 16 }}
    />
  ),
  ImaginationAndCreativity: (
    <ImaginationAndCreativityIllustration
      style={{ position: "absolute", bottom: 20 }}
    />
  ),
  PatternsAndPrinciples: (
    <PatternsAndPrinciplesIllustration
      style={{ position: "absolute", bottom: -16 }}
    />
  ),
  StoriesAndSignals: (
    <StoriesAndSignalsIllustration
      style={{ position: "absolute", bottom: 0 }}
    />
  ),
  PurposeAndBalanceUpdated: (
    <PurposeAndBalanceIllustrationV2
      style={{
        position: "absolute",
        bottom: "-8px",
        width: "220px",
        padding: "32px",
        margin: "28px",
      }}
    />
  ),
  IndividualsAndGroupsUpdated: (
    <IndividualsAndGroupsIllustrationV2
      style={{
        position: "absolute",
        bottom: "-8px",
        width: "220px",
        padding: "32px",
        margin: "28px",
      }}
    />
  ),
  SustainabilityAndSystemsUpdated: (
    <SustainabilityAndSystemsIllustrationV2
      style={{
        position: "absolute",
        bottom: "-8px",
        width: "220px",
        padding: "32px",
        margin: "28px",
      }}
    />
  ),
  ImaginationAndCreativityUpdated: (
    <ImaginationAndCreativityIllustrationV2
      style={{
        position: "absolute",
        bottom: "-8px",
        width: "220px",
        padding: "32px",
        margin: "28px",
      }}
    />
  ),
  PatternsAndPrinciplesUpdated: (
    <PatternsAndPrinciplesIllustrationV2
      style={{
        position: "absolute",
        bottom: "-8px",
        width: "220px",
        padding: "32px",
        margin: "28px",
      }}
    />
  ),
  StoriesAndSignalsUpdated: (
    <StoriesAndSignalsIllustrationV2
      style={{
        position: "absolute",
        bottom: "-8px",
        width: "220px",
        padding: "32px",
        margin: "28px",
      }}
    />
  ),
};
